import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./BodyfriendMain.module.css";
import headerImg from "../../Components/Assets/pageHeaderImg/product_header.jpg";
import API_BASE_URL from "../../config/api";

const BodyfriendMain = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialTab = queryParams.get("type") || "All";
  const initialSort = queryParams.get("sort") || "popularity";

  const [activeTab, setActiveTab] = useState(initialTab);
  const [sortOption, setSortOption] = useState(initialSort);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        // ✅ 如果选择 "All"，不传 type 参数
        const typeParam = activeTab === "All" ? "" : activeTab;
        const response = await fetch(
          `${API_BASE_URL}/fetchProducts.php?type=${encodeURIComponent(typeParam)}&sort=${encodeURIComponent(sortOption)}`
        );
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        console.error("Error fetching products:", error);
        setProducts([]);
      }
    };
    fetchProducts();
  }, [activeTab, sortOption]);

  const handleTabClick = (type) => {
    setActiveTab(type);
    const queryParams = new URLSearchParams({
      type,
      sort: sortOption,
    });
    const newUrl = `/bodyfriend-products?${queryParams.toString()}`;
    window.history.replaceState(null, "", newUrl);
  };

  const handleSortChange = (event) => {
    const newSortOption = event.target.value;
    setSortOption(newSortOption);
    const queryParams = new URLSearchParams({
      type: activeTab,
      sort: newSortOption,
    });
    const newUrl = `/bodyfriend-products?${queryParams.toString()}`;
    window.history.replaceState(null, "", newUrl);
  };

  const getProductImage = (imageUrl) => {
    try {
      return require(`../../Components/Assets/productGif/${imageUrl}`);
    } catch (err) {
      console.error("Image not found:", imageUrl);
      return null;
    }
  };

  // 判断当前分类是否是 Healthcare Robot（决定手机端是否 2 列）
  const isHealthcareRobot = activeTab === "Healthcare Robot";

  return (
    <div className={styles["bodyfriend-main-container"]}>
      <div className={styles["intro-banner"]}>
        <img src={headerImg} alt="Bodyfriend Introduction" />
      </div>

      <div className={styles["wrapContent"]}>
        <div className={styles["tabs"]}>
          {["All", "Healthcare Robot", "Massage sofa", "Massage Chair", "Massage Bed"].map((type) => (
            <button
              key={type}
              className={`${styles["tab-button"]} ${
                activeTab === type ? styles["active"] : ""
              }`}
              onClick={() => handleTabClick(type)}
            >
              {type}
            </button>
          ))}
        </div>

        <div className={styles["sort-section"]}>
          <span>{products.length} cases</span>
          <select
            value={sortOption}
            onChange={handleSortChange}
            className={styles["sort-dropdown"]}
          >
            <option value="popularity">Sort by popularity</option>
          </select>
        </div>

        <div className={`${styles["products-display"]} ${isHealthcareRobot ? styles["two-col"] : ""}`}>
          {products.map((product) => {
            const productImage = getProductImage(product.image_gif);

            return (
              <div key={product.id} className={styles["product-card"]}>
                <Link to={`/${product.slug}`}>
                  {productImage ? (
                    <img
                      src={productImage}
                      alt={product.name}
                      className={styles["product-image"]}
                    />
                  ) : (
                    <p>Image not available</p>
                  )}
                  <br />
                  <h2 className={styles["product-name"]}>{product.name}</h2>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BodyfriendMain;